// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb {\n  position: relative;\n}\n\n.carbonara-settings-nav--container h3 {\n  margin-top: 4px;\n}\n.carbonara-settings-nav--container h6 {\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
